app.service("PremiumLensAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		var service = {
			isProcessing: false,

			// A surgeon's own prices at a practice - whatever they last sent a patient, lens by lens. The pre-op
			// step uses them for each lens the practice hasn't priced.
			getSavedPriceList: function (userId, practiceId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/premium_lenses/setting/user/${userId}?practiceId=${practiceId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
				});
			},
			// A practice's premium lens prices, which override its surgeons' own lens by lens, and the address
			// patients reply to.
			getPracticePrices: function (practiceId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/premium_lenses/practice/${practiceId}/settings`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
				});
			},
			// Replaces the practice's prices and reply address; a lens left out takes each surgeon's own price.
			savePracticePrices: function (practiceId, settings) {
				return $http({
					method: "PUT",
					url: ENV.API + `/api/premium_lenses/practice/${practiceId}/settings`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
					data: settings,
				});
			},
            getEmailsForPatient: function (patientId, practiceId) {
                return $http({
					method: "GET",
					url: ENV.API + `/api/premium_lenses/patient/${patientId}?practiceId=${practiceId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
				});
            },
            submitPrice: function (body) {
				return $http({
					method: "POST",
					url: ENV.API + "/api/premium_lenses/",
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					data: body,
				});

			}
		};

		return service;
	},
]);
